import { DepartmentProps } from "@/types/about-us/about-us.type";
import Image from "next/image";
import React from "react";

const DepartmentCard = ({ data }: { data: DepartmentProps }) => {
  return (
    <div className="overflow-hidden relative h-[450px] max-h-[450px] group rounded-lg">
      <div className="p-6 z-10 relative w-full h-full flex flex-col items-center justify-center gap-2 text-center">
        <p>
          {data.Icon && <data.Icon size={64} className="!text-text" />}
        </p>
        <h1
          className="section-title text-2xl md:text-3xl lg:text-4xl"
          style={{ fontSize: "36px" }}
        >
          {data.title}
        </h1>
        <p className="text-sm md:text-base lg:text-lg text-light-text">{data.description}</p>
      </div>

      <Image
        src={data.image}
        alt={data.title}
        width={1200}
        height={1200}
        className="absolute top-0 left-0 w-full h-full inset-1 object-cover transition-all duration-800 ease-in-out object-center group-hover:scale-110 rounded-lg"
      />
      <div className="absolute top-0 left-0 w-full h-full bg-background/80 rounded-lg" />
    </div>
  );
};

export default DepartmentCard;
